import { FC } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "pages/Dashboard";
import Login from "pages/Login";
import Users from "pages/Users";
import NotFound from "pages/NotFound";
import Admins from "pages/Admins";
import Houses from "pages/Houses";
import ForgotPassword from "pages/ForgotPassword";
import Devices from "pages/Devices";
import Privacy from "pages/Privacy";
import Tos from "pages/Tos";
import RequestDeleteAccount from "pages/RequestDeleteAccount";
import VerifyDeleteAccount from "pages/VerifyDeleteAccount";

const Router: FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/login" element={<Login />} />
        <Route path="/users" element={<Users />} />
        <Route path="/admins" element={<Admins />} />
        <Route path="/houses" element={<Houses />} />
        <Route path="/houses/:id/devices" element={<Devices />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route
          path="/request-delete-account"
          element={<RequestDeleteAccount />}
        />
        <Route
          path="/verify-delete-account"
          element={<VerifyDeleteAccount />}
        />
        <Route path="/tos" element={<Tos />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
